<div class="block--wrap block">
    <footer class="footer">
        <section class="flex-center">
            <div class="footer__column flex1 show-mobile">
                <div class="footer__title">{{ 'FOOTER_SERVICES' | translate }}</div>

                <ul>
                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_SERVICES_ITEM_1_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_SERVICES_ITEM_1' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_SERVICES_ITEM_2_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_SERVICES_ITEM_2' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_SERVICES_ITEM_3_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_SERVICES_ITEM_3' | translate }}</a
                        >
                    </li>
                </ul>
            </div>

            <div class="footer__column flex1 show-mobile">
                <div class="footer__title">{{ 'FOOTER_ADDITIONAL_SERVICES' | translate }}</div>

                <ul>
                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_1_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_1' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_2_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_2' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_3_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_3' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_4_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_ADDITIONAL_SERVICES_ITEM_4' | translate }}</a
                        >
                    </li>
                </ul>
            </div>

            <div class="footer__column flex1">
                <div class="footer__title">{{ 'FOOTER_ACTIONS' | translate }}</div>
                <ul>
                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            [routerLink]="'/purchase/ticket' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'FOOTER_BUY_PERIOD_TICKET' | translate }}</a
                        >
                    </li>

                    <ng-template [ngIf]="ridangoAuth.getLoginStatus()" [ngIfElse]="authLinks">
                        <li class="footer__item">
                            <a
                                class="link--no-line"
                                [routerLink]="'/account/purchase-history' | localize"
                                routerLinkActive="router-link-active">
                                {{ 'MY_ACCOUNT_PURCHASE_HISTORY' | translate }}
                            </a>
                        </li>

                        <li class="footer__item">
                            <a
                                class="link--no-line"
                                [routerLink]="'/account/profile' | localize"
                                routerLinkActive="router-link-active"
                                >{{ 'MY_ACCOUNT_PROFILE' | translate }}
                            </a>
                        </li>

                        <li class="footer__item">
                            <a
                                class="link--no-line"
                                [routerLink]="'/account/related-cards' | localize"
                                routerLinkActive="router-link-active">
                                {{ 'MY_ACCOUNT_CARDS_ACTIVE_TICKETS' | translate }}
                            </a>
                        </li>
                    </ng-template>

                    <ng-template #authLinks>
                        <li class="footer__item">
                            <a
                                class="link--no-line"
                                [routerLink]="'/login' | localize"
                                routerLinkActive="router-link-active"
                                >{{ 'FOOTER_LOG_IN' | translate }}</a
                            >
                        </li>

                        <li class="footer__item">
                            <a
                                class="link--no-line"
                                [routerLink]="'/register' | localize"
                                routerLinkActive="router-link-active"
                                >{{ 'FOOTER_REGISTER' | translate }}</a
                            >
                        </li>
                    </ng-template>
                </ul>
            </div>

            <div class="footer__column flex1">
                <div class="footer__title">{{ 'FOOTER_CUSTOMER_SUPPORT' | translate }}</div>

                <ul>
                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_MAIN_PAGE_LINK' | translate }}"
                            target="_blank"
                            rel="noopener"
                            >{{ 'FOOTER_MAIN_PAGE' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a class="link--no-line" href="{{ 'FOOTER_MAIL_US_LINK' | translate }}">
                            {{ 'FOOTER_MAIL_US' | translate }}</a
                        >
                    </li>

                    <li class="footer__item">
                        <a
                            class="link--no-line"
                            href="{{ 'FOOTER_PHONE_LINK' | translate }}"
                            attr.aria-label="{{ 'FOOTER_CALL_US' | translate }}"
                            >{{ 'FOOTER_PHONE_TEXT' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="footer__additional-info">
            <p class="remove-margin" ridangoTranslatedLink>{{ 'FOOTER_ADDITIONAL_TEXT' | translate }}</p>
        </section>
    </footer>
</div>

<div class="footer-pattern">
    <img class="hide-for-wcag" src="{{ assetsPath$ | async }}/footer-pattern.svg" alt="" />
</div>

<div class="footer-logo">
    <img
        class="hide-for-wcag"
        src="{{ assetsPath$ | async }}/footer-logo-with-label.svg"
        alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
    <img
        class="show-high-contrast-view"
        src="{{ assetsPath$ | async }}/footer-logo-with-label-wcag.svg"
        alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
</div>
